import {
  Card,
  Col,
  LoadMoreSection,
  Row,
  Separator,
  Skeleton,
} from '@repo/ui/components'
import { Fragment } from 'react'
import {
  useGetLoyaltyTransactionHistory,
  useUserAuthDetails,
} from '@repo/services'
import { RewardItem } from '@repo/club/containers'
import { BalanceAssetHistoryEmptyState } from './balance-asset.history.empty-state'

export const BalanceAssetHistory = () => {
  const { data: user } = useUserAuthDetails()
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetLoyaltyTransactionHistory({
      skip: 0,
      limit: 10,
      userID: user?.data?.id ?? 0,
    })
  const transactions =
    data?.pages?.flatMap((page) => page.data?.transactions || []) || []

  return (
    <Row className='min-h-screen items-start  mb-20 md:mb-0'>
      <Card className='flex-1' withoutBorder>
        <Col>
          {isLoading && (
            <div className='space-y-2'>
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
            </div>
          )}
          {transactions?.map((transaction, index) => (
            <Fragment key={transaction.id}>
              {index !== 0 && <Separator />}
              <RewardItem item={transaction} displayTitle='history' />
            </Fragment>
          ))}

          {(transactions || []).length === 0 && !isLoading && (
            <BalanceAssetHistoryEmptyState />
          )}
          <LoadMoreSection
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isLoading={isLoading}
          />
        </Col>
      </Card>
    </Row>
  )
}
